import { handleActions } from 'redux-actions';
import { fetchGruserSuccess } from '../actions/gruser';

const defaultState = {};

export default handleActions<any, any>(
  {
    [fetchGruserSuccess.toString()]: (state, action) => ({
      ...action.payload.gruser,
    }),
  },
  defaultState
);
